<template>
  <px-custom-dialog transition="fadet"
                    width="550"
                    v-model="dialog">
    <template v-slot:activator="{ on }">
      <slot name="activator" v-bind:on="on">
      </slot>
    </template>
    <template v-slot:title>
      Adicionando whatsapps
    </template>
    <template>
      <v-row>
        <v-col cols="12">
          <v-text-field
            dense
            outlined
            hide-details
            type="phone"
            label="whatsapp"
            v-mask="['(##) #####-####']"
            maxlength="20"
            class="rounded-tag-small"
            v-model="whatsapp"
          />
          <div class="adicionar">
            <v-btn small
              class="normal-btn-text rounded-tag-small elevation-0"
              color="primary"
              :disabled="$v.$invalid"
              @click="addWhats">
              <v-icon small>mdi-plus</v-icon>
              Adicionar whatsapp
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <template>
            <v-card outlined class="rounded-card">
              <v-list>
                <v-list-item>
                  <v-list-item-title class="text--primary">
                    Whatsapps
                  </v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item v-for="(item, i) in fornecedor.whatsapps" :key="i">
                  <v-list-item-title>
                    {{ item | phone | naoInformado}}
                  </v-list-item-title>
                  <v-list-item-actions>
                    <v-btn icon small @click="remove(item)">
                      <v-icon small>
                        mdi-close
                      </v-icon>
                    </v-btn>
                  </v-list-item-actions>
                </v-list-item>
                <v-list-item v-if="!fornecedor.whatsapps.length">
                  <v-list-item-title>Nenhum whatsapp informado</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-card>
          </template>
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <v-btn color="primary"
             class="normal-btn-text rounded-tag-small"
             :loading="loading"
             @click="save">
        Salvar
      </v-btn>
      <v-btn text class="normal-btn-text" @click="close">
        Cancelar
      </v-btn>
    </template>
  </px-custom-dialog>
</template>

<script>
import { minLength } from 'vuelidate/lib/validators';
import { onlyNumbers } from '@/utils/regex-utils';
import GestaoFornecedorService from '../gestao-fornecedor-service';

export default {
  props: {
    currentFornecedor: Object,
  },
  data() {
    return {
      dialog: null,
      loading: false,
      whatsapp: null,
      fornecedor: {
        whatsapps: [],
      },
    };
  },
  methods: {
    close() {
      this.whatsapp = null;
      this.dialog = false;
    },
    remove(item) {
      this.fornecedor.whatsapps = this.fornecedor.whatsapps.filter(whats => whats !== item);
    },
    getWhats() {
      GestaoFornecedorService.get(this.currentFornecedor.id)
        .then((response) => {
          const fornecedor = response.data;
          this.fornecedor.whatsapps = fornecedor.whatsapps || [];
        });
    },
    addWhats() {
      if (!(this.fornecedor.whatsapps.includes(onlyNumbers(this.whatsapp)))) {
        this.fornecedor.whatsapps.push(onlyNumbers(this.whatsapp));
        this.whatsapp = null;
      } else {
        this.$toast('Whatsapp já incluso a lista', { color: 'error' });
        this.whatsapp = null;
      }
    },
    initialState() {
      this.getWhats();
    },
    buildPayload() {
      const fornecedor = { ...this.fornecedor };
      return fornecedor;
    },
    save() {
      this.loading = true;
      GestaoFornecedorService.updateWhatsapp(this.currentFornecedor.id, this.buildPayload())
        .then(() => {
          this.close();
          this.$emit('update');
          this.$toast('whatsapps Adicionados', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  watch: {
    dialog(newValue, oldValue) {
      if (newValue === oldValue) {
        return;
      }
      this.initialState();
    },
  },
  validations: {
    whatsapp: {
      minLength: minLength(15),
    },
  },
};
</script>
<style scoped>
.adicionar {
  padding: 0.2rem;
  display: flex;
  justify-content: end;
}
</style>
